import React from 'react';
import { Link } from 'gatsby';
import { ImageWithModal } from '../common';
import StaticImage from '../common/Image';

export default function Events() {
  return (
    <div className="my-16 mb-0 w-full mx-auto px-16">
      <div className="flex flex-col flex-wrap mb-16 min-h-[750px]">
        <p className="text-base leading-relaxed text-justify lg:w-3/4 mx-auto text-gray-500 mb-2">
          La Sociedad Venezolana de Radiología e Imagenología Dentomaxilofacial
          tiene el honor de invitarles a participar en el VI Congreso Nacional
          que se llevará a cabo los días viernes 07 y sabado 08 de Noviembre en
          en la Universidad Santa Maria en la Ciudad de Caracas - Venezuela.
          <br />
          El programa diseñado con conferencias magistrales sobre la Radiologia
          Dentomaxilofacial y sus aplicaciones en las especialidades
          Odontológicas, serán dictadas por reconocidos profesionales.
          <br />
          Esperamos contar con su participación y sea un espacio para compartir
          e intercambiar conocimientos en esta especialidad.
        </p>
        <h2 className="text-center text-blue-700 font-semibold sm:text-3xl text-2xl uppercase mt-4">
          VI Congreso de la SVRID
        </h2>
        {/* <div className="flex mt-4 justify-center">
          <div className="w-16 h-1 rounded-full bg-blue-700 inline-flex" />
        </div> */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 my-8">
          <div className="" />
          <div className="">
            <StaticImage
              filename="congreso-vi.jpeg"
              alt="VI Congreso SVRID"
              className="rounded-lg bg-gray-100 overflow-hidden group-hover:opacity-75 aspect-w-3 aspect-h-4"
              imgClassName="w-full object-top object-cover"
            />
          </div>
          <div className="" />
        </div>
      </div>
      <div className="flex flex-wrap justify-center">
        {/* <div className="p-4 md:w-1/3 md:mb-0 mb-6 flex flex-col text-center items-center">
          <div className="w-20 h-20 inline-flex items-center justify-center rounded-full bg-blue-100 text-blue-700 mb-5 flex-shrink-0">
            <a
              href="https://eventusvip.com/svrid/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                className="w-10 h-10"
                stroke="currentColor"
              >
                <path d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </a>
          </div>
          <div className="flex-grow">
            <h2 className="text-gray-900 text-lg title-font font-medium mb-3 leading-none">
              Inscribirse
            </h2>
            <a
              href="https://eventusvip.com/svrid/"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 text-blue-700 inline-flex items-center"
            >
              Inscribirse
              <svg
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="w-4 h-4 ml-2"
                viewBox="0 0 24 24"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
          </div>
        </div> */}
        {/* <div className="p-4 md:w-1/3 md:mb-0 mb-6 flex flex-col text-center items-center">
          <div className="w-20 h-20 inline-flex items-center justify-center rounded-full bg-blue-100 text-blue-700 mb-5 flex-shrink-0">
            <Link to="/congreso">
              <svg
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                className="w-10 h-10"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                />
              </svg>
            </Link>
          </div>
          <div className="flex-grow">
            <h2 className="text-gray-900 text-lg title-font font-medium mb-3">
              Ver conferencias
            </h2>
            <Link
              to="/congreso"
              className="mt-3 text-blue-700 inline-flex items-center"
            >
              Conferencias
              <svg
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="w-4 h-4 ml-2"
                viewBox="0 0 24 24"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
        </div> */}

        {/* <div className="p-4 md:w-1/3 md:mb-0 mb-6 flex flex-col text-center items-center">
              <div className="w-20 h-20 inline-flex items-center justify-center rounded-full bg-blue-100 text-blue-700 mb-5 flex-shrink-0">
                <Link to="/posters">
                  <svg
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    className="w-10 h-10"
                    stroke="currentColor"
                  >
                    <path d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                  </svg>
                </Link>
              </div>
              <div className="flex-grow">
                <h2 className="text-gray-900 text-lg title-font font-medium mb-3">
                  Pósters
                </h2>
                <p className="leading-relaxed text-base">Del 22 al 30 de julio.</p>
                <Link
                  to="/posters"
                  className="mt-3 text-blue-700 inline-flex items-center"
                >
                  Saber mas
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    className="w-4 h-4 ml-2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            </div> */}
      </div>
    </div>
  );
}
